import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import type { GetCaseByIdQuery } from './get-case-by-id.query';
import type { GetCaseByIdResult } from './get-case-by-id.result';

/**
 * Get case by ID use case.
 * Retrieves a single case by its ID and updates the selected case state.
 */
@Injectable({ providedIn: 'root' })
export class GetCaseByIdUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetCaseByIdQuery): Observable<GetCaseByIdResult> {
    this._state.setLoadingCases(true);
    this._state.setErrorCases(null);

    return this._repository.getCaseById(query.caseId).pipe(
      tap((caseEntity) => {
        this._state.setSelectedCase(caseEntity);
        this._state.setLoadingCases(false);
      }),
      map((caseEntity) => ({ case: caseEntity })),
      catchError((error) => {
        const errorMessage = error.message || 'Failed to load case details';
        this._state.setErrorCases(errorMessage);
        this._state.setLoadingCases(false);
        this._state.setSelectedCase(null);
        return throwError(() => error);
      })
    );
  }
}
